export default __webpack_public_path__ + "static/media/realdataset.66be8d79.jpg";